import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface VehicleHeaderProps {
  year: string;
  brand: string;
  model: string;
  licensePlate: string;
}

const VehicleHeader = ({ year, brand, model, licensePlate }: VehicleHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white border-b">
      <div className="max-w-7xl mx-auto py-6 px-8">
        <div className="mb-6">
          <Button
            variant="ghost"
            className="text-gray-600 hover:text-[#B1A06D] p-0 mb-4 h-auto text-sm"
            onClick={() => navigate("/app/manage-vehicles")}
          >
            <ChevronLeft className="mr-1 h-4 w-4" />
            Terug naar voertuigenoverzicht
          </Button>
        </div>
        <div className="flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
          <div>
            <h1 className="text-2xl font-bold text-[#B1A06D]">
              {year && <span>{year} </span>}
              {brand} {model}
            </h1>
            <p className="text-gray-600">Kenteken: {licensePlate}</p>
          </div>
          <div className="inline-flex h-[60px] items-center">
            <div className="h-full w-[60px] bg-[#1C4B9C] flex items-center justify-center rounded-l-lg">
              <span className="text-white font-bold">NL</span>
            </div>
            <div className="h-full px-6 bg-[#F7C748] flex items-center justify-center rounded-r-lg">
              <span className="text-[#5D4E27] text-2xl font-bold">
                {licensePlate}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleHeader;
